/* Chili Chews scratch-off funnels (Black Friday, Halloween): scratch card, offer page, box builder. No dependencies.
   Each campaign's config sets storeKey/dealName/campaign; Black Friday predates them and uses the defaults. */
(() => {
  const cfgEl = document.getElementById('bf-config');
  if (!cfgEl) return;
  const CFG = JSON.parse(cfgEl.textContent);
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = (cents) => `$${(Math.round(cents) / 100).toFixed(2)}`;
  // Shopify floors a percentage discount per line, so the sale price rounds up by a cent at most
  const salePrice = (cents, rate) => cents - Math.floor((cents * rate) / 100);
  const BITES_PRICE = 1599;
  // Keys are namespaced per campaign so a Halloween scratch never pre-reveals the Black Friday card
  const KEY = CFG.storeKey || 'bf';
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k.replace(/^bf_/, `${KEY}_`)); return v ? JSON.parse(v) : d; } catch (_) { return d; } },
    set(k, v) { try { localStorage.setItem(k.replace(/^bf_/, `${KEY}_`), JSON.stringify(v)); } catch (_) {} },
  };
  const track = (name, data = {}) => {
    data = { campaign: CFG.campaign || 'black_friday', ...data };
    try { window.Shopify?.analytics?.publish?.(name, data); } catch (_) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: name, ...data }); } catch (_) {}
    // GA4 through the store's own Google tag (same cookies, so events join the visitor's session).
    // "campaign" goes out as "funnel": GA4 reads a campaign param as a traffic source and would re-attribute the visit.
    try { if (typeof window.gtag === 'function') { const { campaign, ...rest } = data; window.gtag('event', name, { funnel: campaign, ...rest }); } } catch (_) {}
  };
  const tierFor = (count) => [...CFG.tiers].reverse().find((t) => count >= t.min) || null;
  // How many 2-packs a gift key stands for (sour-buds-x2 is 2 Sour Buds on one code; shipping and the rest are 1)
  const giftQty = (k) => (CFG.gifts.find((g) => g.key === k) || {}).qty || 1;
  const giftTotal = (keys) => keys.reduce((a, k) => a + giftQty(k), 0);
  const pad = (n) => String(Math.max(0, n)).padStart(2, '0');

  /* Countdown to the real offer end */
  const ends = Date.parse(CFG.offerEnds);
  const tick = () => {
    const left = Math.max(0, ends - Date.now());
    const d = Math.floor(left / 864e5), h = Math.floor(left / 36e5) % 24, m = Math.floor(left / 6e4) % 60, s = Math.floor(left / 1e3) % 60;
    $$('[data-bf-timer="inline"]').forEach((el) => { el.textContent = `${pad(d)}d ${pad(h)}:${pad(m)}:${pad(s)}`; });
    $$('[data-bf-timer="box"]').forEach((box) => {
      const set = (u, v) => { const el = box.querySelector(`[data-unit="${u}"]`); if (el) el.textContent = pad(v); };
      set('d', d); set('h', h); set('m', m); set('s', s);
    });
  };
  tick(); setInterval(tick, 1000);

  /* Confetti burst (canvas, no library) */
  const burst = (originEl, { colors = ['#F52E7A', '#FFB32C', '#D6FB51', '#FF4F98', '#83DFFF', '#000000'], count = 140 } = {}) => {
    const c = document.createElement('canvas');
    c.className = 'bf-burst';
    document.body.appendChild(c);
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    c.width = innerWidth * dpr; c.height = innerHeight * dpr;
    const ctx = c.getContext('2d'); ctx.scale(dpr, dpr);
    const r = originEl.getBoundingClientRect();
    const ox = r.left + r.width / 2, oy = r.top + r.height / 2;
    const parts = Array.from({ length: count }, () => ({
      x: ox, y: oy, vx: (Math.random() - 0.5) * 16, vy: Math.random() * -15 - 4, g: 0.38 + Math.random() * 0.2,
      w: 6 + Math.random() * 7, h: 9 + Math.random() * 9, a: Math.random() * 6, va: (Math.random() - 0.5) * 0.4,
      c: colors[(Math.random() * colors.length) | 0],
    }));
    let frame = 0;
    const step = () => {
      ctx.clearRect(0, 0, innerWidth, innerHeight);
      parts.forEach((p) => {
        p.vy += p.g; p.vx *= 0.99; p.x += p.vx; p.y += p.vy; p.a += p.va;
        ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.a); ctx.fillStyle = p.c; ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h); ctx.restore();
      });
      if (++frame < 170) requestAnimationFrame(step); else c.remove();
    };
    requestAnimationFrame(step);
  };

  /* 1. Scratch card */
  const scratch = $('[data-bf-scratch]');
  if (scratch) {
    const card = $('[data-bf-card]', scratch);
    const canvas = $('[data-bf-canvas]', scratch);
    const cta = $('[data-bf-redeem]', scratch);
    const skip = $('[data-bf-reveal-all]', scratch);
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    let revealed = false, drawing = false, last = null, moves = 0;

    const reveal = (how) => {
      if (revealed) return;
      revealed = true;
      card.classList.add('is-revealed');
      cta.hidden = false; skip.hidden = true;
      burst(card);
      store.set('bf_scratched', Date.now());
      track('bf_scratch_reveal', { how });
      setTimeout(() => cta.classList.add('is-pulsing'), 600);
    };

    const paintCover = () => {
      const rect = card.getBoundingClientRect();
      const dpr = Math.min(2, window.devicePixelRatio || 1);
      canvas.width = rect.width * dpr; canvas.height = rect.height * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const w = rect.width, h = rect.height;
      const drawPill = () => {
        const label = 'Scratch here 👉';
        ctx.font = `800 ${Math.round(Math.max(18, w * 0.06))}px Inter, "Arial Black", sans-serif`;
        const tw = ctx.measureText(label).width, ph = Math.max(46, h * 0.2), pw = tw + 44;
        const x = (w - pw) / 2, y = (h - ph) / 2, rr = 10;
        ctx.fillStyle = '#000';
        ctx.beginPath(); ctx.roundRect ? ctx.roundRect(x, y + 4, pw, ph, rr) : ctx.rect(x, y + 4, pw, ph); ctx.fill();
        ctx.fillStyle = '#140b12';
        ctx.beginPath(); ctx.roundRect ? ctx.roundRect(x, y, pw, ph, rr) : ctx.rect(x, y, pw, ph); ctx.fill();
        ctx.fillStyle = '#FFB32C'; ctx.textBaseline = 'middle'; ctx.textAlign = 'center';
        ctx.fillText(label, w / 2, y + ph / 2 + 1);
      };
      const img = new Image();
      img.onload = () => {
        const s = Math.max(w / img.width, h / img.height);
        ctx.globalCompositeOperation = 'source-over';
        ctx.drawImage(img, (w - img.width * s) / 2, (h - img.height * s) / 2, img.width * s, img.height * s);
        drawPill();
      };
      img.onerror = () => { ctx.fillStyle = '#F52E7A'; ctx.fillRect(0, 0, w, h); drawPill(); };
      img.src = canvas.dataset.cover;
    };

    const cleared = () => {
      const { width, height } = canvas;
      const data = ctx.getImageData(0, 0, width, height).data;
      let clear = 0, total = 0;
      for (let y = 4; y < height; y += 12) for (let x = 4; x < width; x += 12) { total++; if (data[(y * width + x) * 4 + 3] < 40) clear++; }
      return clear / total;
    };
    const pos = (e) => { const r = canvas.getBoundingClientRect(); const p = e.touches ? e.touches[0] : e; return { x: p.clientX - r.left, y: p.clientY - r.top }; };
    const scratchAt = (p) => {
      const r = Math.max(22, canvas.getBoundingClientRect().width * 0.07);
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineWidth = r * 2; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      ctx.beginPath(); ctx.moveTo((last || p).x, (last || p).y); ctx.lineTo(p.x, p.y); ctx.stroke();
      ctx.beginPath(); ctx.arc(p.x, p.y, r, 0, Math.PI * 2); ctx.fill();
      last = p;
      if (++moves % 8 === 0 && cleared() > 0.45) reveal('scratch');
    };
    const start = (e) => { if (revealed) return; drawing = true; last = null; scratchAt(pos(e)); e.preventDefault(); };
    const move = (e) => { if (!drawing || revealed) return; scratchAt(pos(e)); e.preventDefault(); };
    const end = () => { drawing = false; last = null; };
    canvas.addEventListener('pointerdown', (e) => { canvas.setPointerCapture?.(e.pointerId); start(e); });
    canvas.addEventListener('pointermove', move);
    canvas.addEventListener('pointerup', end); canvas.addEventListener('pointercancel', end);
    canvas.addEventListener('touchstart', start, { passive: false });
    canvas.addEventListener('touchmove', move, { passive: false });
    skip.addEventListener('click', () => reveal('tap'));
    paintCover();
    let rz; addEventListener('resize', () => { if (revealed) return; clearTimeout(rz); rz = setTimeout(paintCover, 150); });
    // A reveal is remembered for 2 hours (back-button trips to the offer), then the card resets so later visits get to scratch again; ?replay forces a fresh card
    const scratchedAt = Number(store.get('bf_scratched', 0)) || 0;
    if (scratchedAt && Date.now() - scratchedAt < 2 * 3600 * 1000 && !new URLSearchParams(location.search).has('replay')) {
      revealed = true; card.classList.add('is-revealed', 'is-instant'); cta.hidden = false; skip.hidden = true;
    }
    cta.addEventListener('click', () => track('bf_redeem_click'));
  }

  /* Gift panel lock state */
  const syncGifts = (count) => {
    $$('[data-bf-gifts] .bf-gift').forEach((g) => g.classList.toggle('is-locked', count < Number(g.dataset.min)));
  };

  /* 2. Offer page */
  const offer = $('[data-bf-offer]');
  if (offer) {
    const track_ = $('[data-bf-track]', offer);
    const slides = $$('.bf-gallery__slide', offer);
    const thumbs = $$('[data-bf-thumb]', offer);
    const go = (i) => { const n = (i + slides.length) % slides.length; track_.scrollTo({ left: slides[n].offsetLeft, behavior: 'smooth' }); };
    const current = () => Math.round(track_.scrollLeft / Math.max(1, track_.clientWidth));
    $('[data-bf-prev]', offer).addEventListener('click', () => go(current() - 1));
    $('[data-bf-next]', offer).addEventListener('click', () => go(current() + 1));
    thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.bfThumb))));
    track_.addEventListener('scroll', () => { const i = current(); thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i)); }, { passive: true });

    const tiers = $$('[data-bf-tier]', offer);
    const select = (qty) => {
      const t = tierFor(qty);
      tiers.forEach((b) => { const on = Number(b.dataset.bfTier) === qty; b.classList.toggle('is-selected', on); b.setAttribute('aria-checked', on); });
      $$('[data-bf-choose]').forEach((a) => { a.href = `${CFG.builderUrl}?box=${qty}`; });
      $$('[data-bf-rate]').forEach((el) => { el.textContent = t ? t.rate : 0; });
      syncGifts(qty);
      store.set('bf_box', qty);
    };
    tiers.forEach((b) => b.addEventListener('click', () => { select(Number(b.dataset.bfTier)); track('bf_tier_select', { box: Number(b.dataset.bfTier) }); }));
    tiers.forEach((b) => { const t = tierFor(Number(b.dataset.bfTier)); const now = b.querySelector('.bf-tier__now'); if (t && now) now.textContent = `${money(salePrice(BITES_PRICE, t.rate))}/2-pack`; });
    select(Number(store.get('bf_box', 5)) || 5);

    const sticky = $('[data-bf-sticky]');
    const mainCta = $('.bf-buy [data-bf-choose]', offer);
    if (sticky && mainCta && 'IntersectionObserver' in window) {
      // Shown whenever the main button is off screen, so a phone always has a way into the builder from the first screen
      new IntersectionObserver(([en]) => { sticky.hidden = en.intersectionRatio >= 0.9; }, { threshold: [0, 0.9, 1] }).observe(mainCta);
    }
    $$('[data-bf-choose]').forEach((a) => a.addEventListener('click', () => track('bf_choose_flavors', { box: store.get('bf_box', 5) })));
  }

  /* 3. Box builder */
  const builder = $('[data-bf-builder]');
  if (builder) {
    const params = new URLSearchParams(location.search);
    const target = [3, 5, 8].includes(Number(params.get('box'))) ? Number(params.get('box')) : Number(store.get('bf_box', 5)) || 5;
    const list = $('[data-bf-flavors]', builder);
    const tpl = $('#bf-flavor-row');
    // Most of one flavor a box can take: its stock when low, unless Shopify keeps selling it past zero
    const maxFor = (f) => (f.lowStock && !f.oversell ? Math.min(24, f.lowStock) : 24);
    // A saved box keeps only flavors still on sale here, never more than can sell; anything else would fail at add to cart
    const saved = store.get('bf_qty', {});
    const qty = {};
    CFG.flavors.forEach((f) => { const q = Number(saved[f.variantId]) || 0; if (q > 0 && f.available) qty[f.variantId] = Math.min(q, maxFor(f)); });
    const rows = new Map();

    CFG.flavors.forEach((f) => {
      const li = tpl.content.firstElementChild.cloneNode(true);
      li.dataset.variant = f.variantId;
      li.querySelector('img').src = f.thumb; li.querySelector('img').alt = `${f.name} 2-pack`;
      li.querySelector('.bf-flavor__name').textContent = f.name;
      li.querySelector('.bf-flavor__desc').textContent = f.desc;
      li.querySelector('.bf-flavor__size').textContent = f.size;
      if (f.badge) { const b = li.querySelector('.bf-flavor__badge'); b.textContent = f.badge; b.hidden = false; }
      if (f.lowStock) { const l = li.querySelector('.bf-flavor__low'); l.textContent = `🔥 Low stock: only ${f.lowStock} left`; l.hidden = false; }
      if (!f.available) { li.classList.add('is-soldout'); li.querySelector('.bf-add').textContent = 'Sold out'; li.querySelector('.bf-add').disabled = true; }
      const add = li.querySelector('.bf-add'), stepEl = li.querySelector('.bf-step');
      const setQ = (n) => { qty[f.variantId] = Math.max(0, Math.min(maxFor(f), n)); if (!qty[f.variantId]) delete qty[f.variantId]; render(); };
      add.addEventListener('click', () => { setQ((qty[f.variantId] || 0) + 1); track('bf_add_flavor', { flavor: f.name }); });
      li.querySelector('.bf-step__plus').addEventListener('click', () => setQ((qty[f.variantId] || 0) + 1));
      li.querySelector('.bf-step__minus').addEventListener('click', () => setQ((qty[f.variantId] || 0) - 1));
      rows.set(f.variantId, { li, f, add, stepEl });
      list.appendChild(li);
    });

    const titleEl = $('[data-bf-builder-title]', builder);
    const btn = $('[data-bf-checkout]', builder);
    const label = $('[data-bf-checkout-label]', builder);
    const err = $('[data-bf-error]', builder);

    // A/B test, Oct 21: half of shoppers see the box $ total on the checkout button ("total"), half keep percent-only ("control").
    // 72% of checkout visits were leaving on the first screen, where the total first appeared. ?total=1 or ?total=0 forces a side.
    const forced = params.get('total');
    let abVariant = forced === '1' ? 'total' : forced === '0' ? 'control' : store.get('bf_ab_total', null);
    if (abVariant !== 'total' && abVariant !== 'control') abVariant = Math.random() < 0.5 ? 'total' : 'control';
    store.set('bf_ab_total', abVariant);
    track('bf_ab_total', { variant: abVariant });
    // Shipping note A/B (Oct 29): half of shoppers see a 3 or 4 pack box's shipping cost before checkout, next to the free
    // shipping step. The builder skips the cart, so otherwise the first time they see the $7.49 is on Shopify's checkout.
    const forcedShip = params.get('ship');
    let shipVariant = forcedShip === '1' ? 'show' : forcedShip === '0' ? 'hide' : store.get('bf_ab_ship', null);
    if (shipVariant !== 'show' && shipVariant !== 'hide') shipVariant = Math.random() < 0.5 ? 'show' : 'hide';
    store.set('bf_ab_ship', shipVariant);
    track('bf_ab_ship', { variant: shipVariant });
    const shipNote = document.createElement('p');
    shipNote.className = 'bf-cartbar__ship';
    shipNote.dataset.bfShip = '';
    shipNote.hidden = true;
    btn.before(shipNote);

    // Deal progress bar (Oct 22): one stop per tier, built from the config ladder so tier or gift changes carry through.
    // Each stop shows its % and an icon per gift that tier adds; reaching a stop pops it and fires confetti in the skin's colors.
    const progress = $('[data-bf-progress]', builder);
    const fill = $('.bf-progress__fill', progress);
    const MAX = CFG.tiers[CFG.tiers.length - 1].min;
    const ICONS = {
      shipping: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M1.5 5.5h12v10h-12zM13.5 9h4.5l3.5 3.5v3h-8z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><circle cx="6" cy="17.5" r="2.2" fill="currentColor"/><circle cx="17" cy="17.5" r="2.2" fill="currentColor"/></svg>',
      gift: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4.5 11h15v9.5h-15zM3 7h18v4H3zM12 7v13.5M12 7C10.5 4 7 3.5 7 5.6S10 7 12 7zm0 0c1.5-3 5-3.5 5-1.4S14 7 12 7z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>',
    };
    const stops = CFG.tiers.map((t, i) => {
      const added = t.gifts.filter((k) => !(i ? CFG.tiers[i - 1].gifts : []).includes(k));
      const s = document.createElement('div');
      s.className = 'bf-progress__stop';
      s.style.left = `${(t.min / MAX) * 100}%`;
      s.innerHTML = `<b>${t.rate}%</b>${added.length ? `<span>${added.map((k) => ICONS[k === 'shipping' ? 'shipping' : 'gift'].repeat(giftQty(k))).join('')}</span>` : ''}`;
      $('.bf-progress__rail', progress).appendChild(s);
      return s;
    });
    const confetti = getComputedStyle(builder).getPropertyValue('--bf-confetti').split(',').map((c) => c.trim()).filter(Boolean);
    const calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let reached = null; // last tier index shown; null until the first render, so a box restored from storage never fires confetti

    // Box subtotal as checkout prices it: Shopify floors the percent discount per unit (14.99 at 30% is 4.49 off each)
    const boxPay = (rate) => {
      let pay = 0;
      rows.forEach(({ f }) => { if (f.available) pay += (qty[f.variantId] || 0) * salePrice(f.price, rate); });
      return pay;
    };
    // Shopify's Standard rate is already free above this subtotal (after discounts); set in cc-funnel-offer
    const FREE_SHIP_CENTS = CFG.freeShipOver || 5499;
    // Standard rate below the free line, from the shipRates ladder in cc-funnel-offer ([below cents, fee cents], lowest first)
    const shipFee = (cents) => cents >= FREE_SHIP_CENTS ? 0 : ((CFG.shipRates || []).find(([below]) => cents < below) || [0, 749])[1];

    function render() {
      const count = Object.values(qty).reduce((a, b) => a + b, 0);
      const t = tierFor(count);
      const rate = t ? t.rate : 0;
      const shownRate = rate || CFG.tiers[0].rate;
      rows.forEach(({ li, f, add, stepEl }) => {
        const q = qty[f.variantId] || 0;
        add.hidden = q > 0 && f.available; stepEl.hidden = !(q > 0 && f.available);
        li.querySelector('.bf-step__qty').textContent = q;
        li.querySelector('.bf-step__plus').disabled = q >= maxFor(f);
        li.classList.toggle('is-in', q > 0);
        li.querySelector('.bf-flavor__was').textContent = money(f.price);
        li.querySelector('.bf-flavor__now').textContent = `${money(salePrice(f.price, shownRate))}/2-pack`;
      });
      titleEl.textContent = count >= target ? `Your box: ${count} two-packs` : `Pick at least ${target} two-packs`;
      $('[data-bf-saving]', builder).textContent = `${rate}%`;
      const gifts = t ? giftTotal(t.gifts) : 0;
      $('[data-bf-gift-count]', builder).textContent = `${gifts}/${giftTotal(CFG.gifts.map((g) => g.key))}`;
      $('[data-bf-count]', builder).textContent = count;
      $$('[data-bf-ladder] [data-step]', builder).forEach((s) => s.classList.toggle('is-on', count >= Number(s.dataset.step)));
      syncGifts(count);
      // The bar is visual only; screen readers get the same next-goal line through aria-valuetext
      const [t1, t2, t3] = CFG.tiers;
      const packs = (t) => t.gifts.filter((k) => k !== 'shipping');
      const giftLabel = (k) => (CFG.gifts.find((g) => g.key === k) || {}).label;
      const plural = (n) => `${n} free 2-pack${n === 1 ? '' : 's'}`;
      let cue;
      if (count < t1.min) cue = `Add ${t1.min - count} more to unlock ${t1.rate}% off every 2-pack`;
      else if (count < t2.min) cue = `Add ${t2.min - count} more for ${t2.rate}% off, free shipping${packs(t2).length ? ` and a free ${giftLabel(packs(t2)[0])}` : ''}`;
      else if (count < t3.min) cue = `Add ${t3.min - count} more for ${t3.rate}% off and ${plural(giftTotal(packs(t3)) - giftTotal(packs(t2))).replace('free', 'more free')}`;
      else cue = `Max deal unlocked: ${t3.rate}% off, free shipping and ${plural(giftTotal(packs(t3)))}`;
      // Only on the paid-shipping tier: the box total decides the fee, the next tier is free shipping plus its gift
      const fee = t === t1 ? shipFee(boxPay(t1.rate)) : 0;
      shipNote.hidden = !(shipVariant === 'show' && fee > 0);
      if (!shipNote.hidden) {
        const more = t2.min - count;
        const gift = giftTotal(packs(t2));
        shipNote.innerHTML = `+ ${money(fee)} shipping, or <b>add ${more} more</b> for free shipping${gift ? ` + ${gift === 1 ? 'a free 2-pack' : plural(gift)}` : ''}`;
      }
      progress.setAttribute('aria-valuemax', MAX);
      progress.setAttribute('aria-valuenow', Math.min(count, MAX));
      progress.setAttribute('aria-valuetext', cue);
      fill.style.width = `${Math.min(1, count / MAX) * 100}%`;
      const tierIdx = CFG.tiers.indexOf(t);
      stops.forEach((s, i) => { s.classList.toggle('is-on', i <= tierIdx); s.classList.toggle('is-next', i === tierIdx + 1); });
      if (reached !== null && tierIdx > reached) {
        const s = stops[tierIdx];
        s.classList.remove('is-pop'); void s.offsetWidth; s.classList.add('is-pop');
        if (!calm) burst(s, { colors: confetti.length ? confetti : undefined, count: tierIdx === stops.length - 1 ? 170 : 90 });
      }
      reached = tierIdx;
      btn.disabled = count < CFG.tiers[0].min;
      const pay = boxPay(rate);
      const showTotal = abVariant === 'total' && !!t;
      label.textContent = count < CFG.tiers[0].min ? `Pick at least ${CFG.tiers[0].min} two-packs` : showTotal ? `Checkout · ${money(pay)}` : `Checkout · ${rate}% off`;
      store.set('bf_qty', qty);
    }
    render();

    const api = async (url, body) => {
      const res = await fetch(url, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined });
      const json = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(json.description || json.message || 'Cart request failed');
      return json;
    };

    btn.addEventListener('click', async () => {
      const count = Object.values(qty).reduce((a, b) => a + b, 0);
      const t = tierFor(count);
      if (!t) return;
      btn.disabled = true; btn.classList.add('is-busy'); err.hidden = true;
      try {
        const cart = await api('/cart.js');
        // Clear earlier box lines and any stray copy of a gift: a second gift line would split its $ off code across both
        const giftIds = CFG.gifts.map((g) => g.variantId).filter(Boolean);
        const stale = {};
        (cart.items || []).forEach((it) => { if ((it.properties && it.properties._bf) || giftIds.includes(it.variant_id)) stale[it.key] = 0; });
        if (Object.keys(stale).length) await api('/cart/update.js', { updates: stale });
        const items = Object.entries(qty).map(([id, q]) => ({ id: Number(id), quantity: q, properties: { _bf: 'box' } }));
        CFG.gifts.forEach((g) => { if (g.variantId && t.gifts.includes(g.key)) items.push({ id: g.variantId, quantity: g.qty || 1, properties: { _bf: 'gift', _bf_gift: g.label } }); });
        await api('/cart/add.js', { items });
        // The hidden _bf_test attribute rides onto the order, so the test reads straight from Shopify orders
        const shipCode = t.codes.find((c) => /FREESHIP$/.test(c));
        const base = t.codes.filter((c) => c !== shipCode);
        let after = await api('/cart/update.js', { discount: base.join(','), attributes: { _bf_test: `total_${abVariant}`, _bf_ship_test: `ship_${shipVariant}` } });
        // The free shipping code goes on only while Shopify would still charge shipping on this exact cart (its total also
        // counts other items and automatic discounts). Above the line shipping is $0 and checkout calls the code "not available".
        // Shopify can answer before the codes finish pricing the cart (a gift briefly shows at the box % instead of $0), so read
        // it until the box lines show the tier price and every gift is free; if it never settles, use the box math plus
        // whatever else is in the cart.
        const boxCents = boxPay(t.rate);
        const isBox = (it) => it.properties && it.properties._bf === 'box';
        const isGift = (it) => it.properties && it.properties._bf === 'gift';
        const settled = (c) => (c.items || []).filter(isBox).reduce((a, it) => a + it.final_line_price, 0) === boxCents && (c.items || []).filter(isGift).every((it) => it.final_line_price === 0);
        // Products only: once a cart has a shipping address, Shopify's total_price on this reply also carries the shipping estimate
        const itemsTotal = (c) => (c.items || []).reduce((a, it) => a + it.final_line_price, 0) - (c.cart_level_discount_applications || []).reduce((a, d) => a + (d.total_allocated_amount || 0), 0);
        let cartTotal = null;
        for (let i = 0; i < 8 && cartTotal === null; i++) {
          if (i) { await new Promise((r) => setTimeout(r, 400)); after = await api('/cart.js'); }
          if (settled(after)) cartTotal = itemsTotal(after);
        }
        if (cartTotal === null) cartTotal = boxCents + (after.items || []).filter((it) => !(it.properties && it.properties._bf)).reduce((a, it) => a + it.final_line_price, 0);
        if (shipCode && cartTotal < FREE_SHIP_CENTS) after = await api('/cart/update.js', { discount: [...base, shipCode].join(',') });
        const applied = (after.discount_codes || []).filter((d) => d.applicable).map((d) => d.code.toUpperCase());
        // Box and gift codes must all stick, or the customer would pay for a "free" gift; free shipping is settled at checkout
        if (!t.codes.filter((c) => !/FREESHIP$/.test(c)).every((c) => applied.includes(c))) throw new Error('code');
        track('bf_checkout', { box: count, rate: t.rate, codes: applied.join(','), variant: abVariant, ship_variant: shipVariant });
        location.href = '/checkout';
      } catch (e) {
        err.textContent = e.message === 'code'
          ? `We couldn't apply your ${CFG.dealName || 'Black Friday'} price. Refresh the page and try again, or email support@chilichews.com.`
          : e.message && e.message !== 'Cart request failed' && !/^Failed to fetch/.test(e.message)
            ? `${e.message} Change that flavor and try again.` // Shopify's own words, e.g. a flavor that just ran low
            : "Something went wrong adding your box. Please try again.";
        err.hidden = false; btn.disabled = false; btn.classList.remove('is-busy');
      }
    });
  }
})();
